/**
 * Classe view para a tela de HOSMap
 *
 * @author: Adalto Junior
 * DATE: 15/05/2013
 */

App.Views.HOSMaps = {

    showFilter: function () {

        var error = null;

        try {
            App.Forms.HOS = App.Forms.HOS || {};
            App.Forms.HOS.layout = App.Forms.HOS.layout || {};

            var layout = App.Forms.HOS.layout.show;
            var entity = 'HOS';

            var callback = function () {
                var hosFilter = new Greenmile.HoursOfService.Filter();
                hosFilter.createFilter();

                App.Forms.HOS.hosFilter = hosFilter;

            };

            if (!layout) {

                var pageLayout = new Monet.PageLayout();
                pageLayout.getLayout(entity, 'show', callback);

            } else {

                callback();

            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on initialize map", e);
            error.console();
        }

    },

    removeHosOnMap: function (map) {

        var error = null,
            layers = map._layers;

        try {

            for (var i in layers) {

                if (layers[i].hosType) {

                    map.removeLayer(layers[i]);

                }

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on remove HOS on map", e);
            error.console();

        }
    },

    drawMarkersFromSearchByDriver: function (hosCollection, map) {

        var error = null,
            mapEvents = null,
            fitBounds = true;

        try {

            if (typeof map !== "undefined" && typeof hosCollection.models !== "undefined") {

                mapEvents = new Greenmile.HoursOfService.MapEvents("#HosMapDisplay");

                this.removeHosOnMap(map);

                mapEvents.drawMarkers(hosCollection, map, fitBounds, "create");

            } else {

                error = new Monet.Exception.ReturnError(this,
                    "Parametters is undefined on format and draw markers");
                error.console();

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on draw marker on routeDetail", e);
            error.console();

        }

    },

    showLogBook: function (hosCollection) {

        var error = null,
            selectorChart = "#HosMapDisplay #logBook #chart",
            selectorSummary = "#HosMapDisplay #logBook #summaryInformation",
            screen = null,
            logBook = null,
            summary = null;

        try {

            if (typeof hosCollection.models !== "undefined") {

                screen = Monet.Session.HOS;

                this.setHeightToLogBook();
                this.addEventListennersLogBook();

                logBook = new Greenmile.HoursOfService.LogBookChart(selectorChart, hosCollection, screen);
                summary = new Greenmile.HoursOfService.SummaryInformation(selectorSummary, hosCollection, screen);

                logBook.drawChart();
                summary.showSummaryInformation();

                $("#logBook").tabs();

            } else {

                error = new Monet.Exception.ReturnError(this,
                    "Parameters is undefined on show log book chart");
                error.console();

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on show log book chart");
            error.console();

        }

        Greenmile.HoursOfService.Utils.adjustMapSize();

    },


    addEventListennersLogBook: function () {

        var error = null,
            selectorLogBook = "#HosMapDisplay #logBook",
            selectorHideLogBook = "#HosMapDisplay #btnHideLogBook",
            selectorShowLogBook = "#HosMapDisplay #btnShowLogBook",
            container = null,
            btnHide = null,
            btnShow = null;

        try {

            container = document.querySelector(selectorLogBook);
            btnHide = document.querySelector(selectorHideLogBook);
            btnShow = document.querySelector(selectorShowLogBook);

            var showLogBook = function () {

                if (container !== null) {
                    container.style.display = "block";
                    Greenmile.HoursOfService.Utils.adjustMapSize();
                }

                btnShow.style.display = "none";

            };

            var hideLogBook = function () {

                if (container !== null) {
                    container.style.display = "none";
                    Greenmile.HoursOfService.Utils.adjustMapSize();
                }

                btnShow.style.display = "block";

            };


            if (container !== null) {
                container.style.display = "block";
            }


            if (btnHide !== null) {

                btnHide.style.display = "block";

                btnHide.removeEventListener("click", hideLogBook);
                btnHide.addEventListener("click", hideLogBook);

            }

            if (btnShow !== null) {

                btnShow.removeEventListener("click", showLogBook);
                btnShow.addEventListener("click", showLogBook);

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on add event listenners to log book.");
            error.console();

        }

    },

    setHeightToLogBook: function () {
        var error = null,
            logBookSelector = "#HosMapDisplay #logBook",
            logBook = null;

        try {

            logBook = document.querySelector(logBookSelector);

            if (logBook) {
                logBook.style.height = "280px";
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on set height to log book.");
            error.console();

        }
    }
};
